import React, { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { WifiOff } from 'lucide-react';

const OfflineBanner: React.FC = () => {
  const { isOnline } = useNetworkStatus();
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
    } else if (wasOfflineRef.current) {
      // Just came back online
      wasOfflineRef.current = false;
      toast.success('Back online', { duration: 3000 });
    }
  }, [isOnline]);

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2 shadow-md">
      <WifiOff className="w-4 h-4" />
      You are offline. Some features may not work until your connection is restored.
    </div>
  );
};

export default OfflineBanner;
